import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'
import { ContactForm } from '@/components/website/ContactForm'
import { useWebsiteContact } from '@/services/httpServices/queries/useWebsite'
import { socials } from '@/data/site'

/** `tel:` href that keeps a leading `+` but drops spaces/separators. */
function toTelHref(phone: string): string {
  const cleaned = phone.replace(/[^\d+]/g, '')
  return `tel:${cleaned}`
}

export function Contact() {
  const { contact } = useWebsiteContact()

  const phones = [contact.phone, contact.phoneAlt].filter(Boolean)

  return (
    <>
      <PageBreadcrumb title="Contact Us" />

      {/* contact section start */}
      <section className="contact-section pt-100 md-pt-80 md-pb-50">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-lg-5">
              {/* section title start */}
              <div className="section-title wow fadeInUp" data-wow-delay=".2s">
                <span className="sub-title">Contact Me</span>
                <h2>Stay connect with us today</h2>
              </div>
              {/* section title end */}

              {/* contact item wrapper start */}
              <div className="contact-item-wrapper">
                {/* contact items start */}
                <div className="contact-item wow fadeInUp" data-wow-delay=".5s">
                  <div className="contact-icon">
                    <i className="fa-solid fa-phone-volume"></i>
                  </div>
                  <div className="contact-content">
                    <p>Call Now</p>
                    {phones.map((phone) => (
                      <h3 key={phone}>
                        <a href={toTelHref(phone)}>{phone}</a>
                      </h3>
                    ))}
                  </div>
                </div>
                {/* contact items end */}

                {/* contact items start */}
                <div className="contact-item wow fadeInUp" data-wow-delay=".4s">
                  <div className="contact-icon">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div className="contact-content">
                    <p>Email</p>
                    <h3>
                      <a href={`mailto:${contact.email}`}>{contact.email}</a>
                    </h3>
                  </div>
                </div>
                {/* contact items end */}

                {/* contact items start */}
                <div className="contact-item wow fadeInUp" data-wow-delay=".3s">
                  <div className="contact-icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div className="contact-content">
                    <p>Address</p>
                    <h3>{contact.address}</h3>
                  </div>
                </div>
                {/* contact items end */}
              </div>
              {/* contact item wrapper end */}

              <div className="contact-social-links wow fadeInUp" data-wow-delay=".6s">
                <span className="follow-text">Follow Us Today :</span>
                <ul className="social-icon">
                  {socials.map((social) => (
                    <li key={social.label}>
                      <a href={social.href} aria-label={social.label.toLowerCase()}>
                        <i className={social.icon}></i>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-6">
              {/* contact form box start */}
              <div className="contact-form-box">
                <div className="section-title">
                  <h2>Send us a message</h2>
                </div>
                <div className="default-form contact-form">
                  <ContactForm />
                </div>
              </div>
              {/* contact form box end */}
            </div>
          </div>
        </div>
      </section>
      {/* contact section end */}

      {/* Google Map start */}
      {contact.mapEmbedUrl && (
        <div className="google-map">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 p-0">
                {/* google map iframe start */}
                <div className="google-map-iframe">
                  <iframe
                    src={contact.mapEmbedUrl}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="google map"
                  ></iframe>
                </div>
                {/* google map iframe end */}
              </div>
            </div>
          </div>
        </div>
      )}
      {contact.mapLinkUrl && (
        <div style={{ textAlign: 'center', padding: '30px 0' }}>
          <a
            href={contact.mapLinkUrl}
            target="_blank"
            rel="noreferrer"
            className="theme-button style-1"
          >
            <span data-text="Open in Google Maps">Open in Google Maps</span>
            <i className="fa-solid fa-location-arrow"></i>
          </a>
        </div>
      )}
      {/* Google Map end */}
    </>
  )
}
